module.exports = __webpack_public_path__ + "static/img/role.4d8f8c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/bn/role.png
// module id = h9U2
// module chunks = 7